export const parseDate = (d) => (d ? new Date(d) : new Date());

export const mapOfferDetailToFormValues = (data, baseInitialValues) => {
    const shops = data?.OfferTarget || [];

    return {
        ...baseInitialValues,
        ...data,
        validStartDate: parseDate(data.validStartDate),
        validEndDate: parseDate(data.validEndDate),
        rentStartDate: parseDate(data.rentStartDate),
        rentEndDate: parseDate(data.rentEndDate),
        rmbDiscount: data?.rmbDiscount ?? '',
        supplierDiscount: data?.supplierDiscount ?? '',
        shops: shops
            .filter((s) => s.type === 'SHOP')
            .map((s) => ({
                shop_id: s.targetId,
                shop_name: s.targetName,
                shop_location: s.location ?? '',
                supplier_company_name: s.companyName ?? '',
            })),
    };
};

export const mapShopRows = (rows) => {
    const list = Array.isArray(rows) ? rows : rows?.data || [];
    return list.map((s) => ({
        id: s.id,
        name: s.name,
        locationName: s.locationName ?? s.location?.name ?? '',
        companyName: s.companyName ?? s.company?.companyName ?? '',
    }));
};

export const buildOfferPayload = (values, { hideRmbDiscount }) => {
    return {
        validStartDate: values.validStartDate,
        validEndDate: values.validEndDate,
        rentStartDate: values.rentStartDate,
        rentEndDate: values.rentEndDate,
        rmbDiscount: String(hideRmbDiscount ? 0 : values.rmbDiscount || '0'),
        supplierDiscount: String(values.supplierDiscount || '0'),
        minDay: Number(values.minDay || 0),
        targets: (values.shops || []).map((s) => ({
            type: 'SHOP',
            targetId: s.shop_id,
        })),
    };
};